// assets
import FakeImg from "src/assets/images/home/to_delete2.png";
const Follower = "https://randomuser.me/api/portraits/men/1.jpg";

export const notifications = {
  new: [
    {
      id: 1,
      image: FakeImg,
      overview: "Your event at Rajat Bar is starting at",
      action: "9:00pm",
      time: "7:35 AM",
      isFollow: false,
    },
    {
      id: 2,
      image: FakeImg,
      overview: "America airlines area just added a",
      action: "NEW EVENT",
      time: "4 mins ago",
      isFollow: true,
    },
  ],
  earlier: [
    {
      id: 1,
      image: FakeImg,
      overview: "Your event at Rajat Bar is starting at",
      action: "9:00pm",
      time: "7:35 AM",
      isFollow: false,
    },
    {
      id: 2,
      image: FakeImg,
      overview: "America airlines area just added a",
      action: "NEW EVENT",
      time: "4 mins ago",
      isFollow: false,
    },
    {
      id: 3,
      image: FakeImg,
      overview: "Justin Bieber tickets just went on",
      action: "sale in New York",
      time: "20 mins ago",
      isFollow: true,
    },
    {
      id: 4,
      image: FakeImg,
      overview: "Your event at Rajat Bar is starting at",
      action: "9:00pm",
      time: "7:35 AM",
      isFollow: false,
    },
    {
      id: 5,
      image: FakeImg,
      overview: "America airlines area just added a",
      action: "NEW EVENT",
      time: "4 mins ago",
      isFollow: true,
    },
    {
      id: 6,
      image: FakeImg,
      overview: "Justin Bieber tickets just went on",
      action: "sale in New York",
      time: "20 mins ago",
      isFollow: true,
    },
  ],
};

export const followers = [
  {
    id: 1,
    image: Follower,
    name: "Airline Areana",
  },
  {
    id: 2,
    image: Follower,
    name: "Djakf",
  },
  {
    id: 3,
    image: Follower,
    name: "Ajofsdg",
  },
  {
    id: 4,
    image: Follower,
    name: "Trabla ieda",
  },
  {
    id: 5,
    image: Follower,
    name: "Poterw Qre",
  },
  {
    id: 6,
    image: Follower,
    name: "Iutrewmn",
  },
  {
    id: 1,
    image: Follower,
    name: "Airline Areana",
  },
  {
    id: 2,
    image: Follower,
    name: "Djakf",
  },
  {
    id: 3,
    image: Follower,
    name: "Ajofsdg",
  },
  {
    id: 4,
    image: Follower,
    name: "Trabla ieda",
  },
  {
    id: 5,
    image: Follower,
    name: "Poterw Qre",
  },
  {
    id: 6,
    image: Follower,
    name: "Iutrewmn",
  },
];
